import * as Permissions from 'permissions';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { MenuItem } from '../';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { SidebarMapSearch, SearchResultsSidebar } from '../maps';

class Navigation extends React.Component {
  componentDidMount() {
    this.$html = $('html').addClass('sidebar-left-collapsed');
  }
  navigate() {
    if(!this.props.show_sidebar_container) {
      this.props.toggleShowSidebarContainer(true)
    }

		this.$html.removeClass('sidebar-left-opened');
	}
	render() {
		return (
			<aside id='sidebar-left' className='sidebar-left'>
				<div className='sidebar-header'>
					<div className='sidebar-title'>
						Navigation
					</div>
					<div
						className='sidebar-toggle hidden-xs'
						data-toggle-class='sidebar-left-collapsed'
						data-target='html'
						data-fire-event='sidebar-left-toggle'
						>
						<i className='fa fa-bars' aria-label='Toggle sidebar'></i>
					</div>
				</div>
				<div className='nano'>
					<div className='nano-content'>
						<nav id='menu' className='nav-main' role='navigation'>
							<ul className='nav nav-main'>
								<li>
									<Link to='dashboard/summary'>
										<i className='fa fa-dashboard' aria-hidden='true'></i>
										<span>Dashboard</span>
									</Link>
								</li>
								{(()=>{
									if(
										this.props.hasPermission(Permissions.CREATE_MAPS) &&
										this.props.hasPermission(Permissions.EDIT_MAPS) &&
										this.props.hasPermission(Permissions.DELETE_MAPS) &&
										this.props.hasPermission(Permissions.VIEW_MAPS) &&
										this.props.hasPermission(Permissions.SEARCH_MAPS)
									) {
										return (
											<MenuItem key='map' title='Map' iconClass='fa fa-map'>
												<MenuItem key='map-search' title='Search' iconClass='fa fa-search' path='/clients/map' />
												<MenuItem key='map-craete' title='Create' iconClass='fa fa-plus' path='/map/create' />
											</MenuItem>
										);
									}
									if(
										this.props.hasPermission(Permissions.SEARCH_MAPS) ||
										this.props.hasPermission(Permissions.VIEW_MAPS)
									) {
										return (
											<MenuItem title='Map' path='/clients/map' iconClass='fa fa-map' />
										);
									}
								})()}
								{(()=>{
									if(this.props.hasPermission(Permissions.VIEW_BLOG_EDITOR)) {
										return (
											<MenuItem title='Posts' path='/posts' iconClass='fa fa-copy'/>
										);
									}
								})()}
								{(()=>{
									if(
                    this.props.hasPermission(Permissions.MANAGE_PAGE_TEMPLATES) ||
                    this.props.hasPermission(Permissions.MANAGE_PAGE_CONTENT)
                  ) {
										return (
											<MenuItem title='Sales Site' path='/sales-site' iconClass='fa fa-globe'/>
										);
									}
								})()}
                {(()=>{
                  if(this.props.hasPermission(Permissions.VIEW_OPPORTUNITIES)) {
                    return (
                      <MenuItem title='Opportunities' iconClass='fa fa-handshake-o'>
                        <MenuItem title='List' path='opportunities' iconClass='fa fa-list' />
                        <MenuItem title='Table' path='opportunities-table' iconClass='fa fa-table' />
                      </MenuItem>
                    )
                  }
                })()}
                {this.props.hasPermission(Permissions.VIEW_CANVASSING_MARKERS) ?
                  <MenuItem title='Canvassing' iconClass='fa fa-bullhorn'>
                    <MenuItem title='Map' iconClass='fa fa-map' path='/clients/canvassing' />
                    {this.props.hasPermission(Permissions.CREATE_CANVASSING_REGIONS) ? (
                      <MenuItem title='Regions' iconClass='fa fa-globe' path='/canvassing-regions' />
                    ) : null}
                    <MenuItem title='Upload' iconClass='fa fa-upload' path='/canvassing/upload' />
                  </MenuItem>
                :''}

                {(()=>{
                  if(this.props.hasPermission(Permissions.VIEW_CLIENTS)) {
                    return (
                      <MenuItem title='Clients' iconClass='fa fa-users'>
                        <MenuItem title='List' iconClass='fa fa-list' path='/clients' />
                        <MenuItem title='Map' iconClass='fa fa-map' path='/clients/map' />
                        {this.props.hasPermission(Permissions.VIEW_CRM_SETTINGS) ?
                          <MenuItem title='Settings' iconClass='fa fa-cog' path='/clients/settings' /> :
                          ''}
                        {this.props.hasPermission(Permissions.UPLOAD_CLIENTS) ?
                          <MenuItem title='Upload' iconClass='fa fa-upload' path='/clients/upload' /> :
                          ''}
                      </MenuItem>
                    );
                  }
                })()}
                {(() => {
                  if(this.props.hasPermission(Permissions.VIEW_REPORTS)) {
                    return (
                      <MenuItem title='Reports' path='reports' iconClass='fa fa-file-text-o'>
                        {this.props.hasPermission(Permissions.VIEW_CANVASSING_REPORT) ? (
                          <MenuItem title='Canvassing Report' iconClass='fa fa-map-pin' path='/reports/canvassing-report' />
                        ) : null}
                      </MenuItem>
                    )
                  }
                  else {
                    return null;
                  }
                })()}
                <MenuItem title='Weather Center' path='live-weather-center' iconClass='fa fa-bolt' />
                <MenuItem title='Account Settings' iconClass='fa fa-cogs'>
                  <MenuItem title='Notification Settings' iconClass='fa fa-cog' path='/settings/notification-settings' />
                  {this.props.hasPermission(Permissions.VIEW_USERS) ? (
                    <MenuItem title='User Management' path='/users' iconClass='fa fa-user' />
                  ): null}
                  {(
                    this.props.hasPermission(Permissions.VIEW_PERMISSIONS) &&
                    this.props.hasPermission(Permissions.CREATE_PERMISSIONS) &&
                    this.props.hasPermission(Permissions.EDIT_PERMISSIONS) &&
                    this.props.hasPermission(Permissions.DELETE_PERMISSIONS)
                  ) ? (
                    <MenuItem title='Permissions' path='/permissions' iconClass='fa fa-minus-circle' />
                  ) : null}
                  {this.props.hasPermission(Permissions.BILLING) ? (
                    <MenuItem title='Account and Billing' path='/account/billing' iconClass='fa fa-credit-card' />
                  ) : null}
                  {this.props.hasPermission(Permissions.BILLING) ? (
                    <MenuItem title='Subscriptions' path='/settings/subscriptions' iconClass='fa fa-dollar' />
                  ) : null}
                  {this.props.hasPermission(Permissions.INTEGRATIONS) ? (
                    <MenuItem title='Integrations' path='/settings/integrations' iconClass='fa fa-plug' />
                  ) : null}
                </MenuItem>
                {this.props.hasPermission(Permissions.VIEW_NOTIFICATIONS) ? (
                  <MenuItem title='Notifications' path='/notifications' iconClass='fa fa-bell' />
                ) : null}
                <MenuItem title='Help' path='/help' iconClass='fa fa-info-circle' />
                {this.props.hasPermission(Permissions.VIEW_ERROR_LOGS) ? (
                  <MenuItem title='Error Logs' path='/error-logs' iconClass='fa fa-exclamation-circle' />
                ) : null}
              </ul>
            </nav>
            <hr className='separator' />
            <SearchResultsSidebar />
          </div>
        </div>
      </aside>
    );
  }
};

module.exports = connect(() => ({}), Actions)(Navigation);



// WEBPACK FOOTER //
// ./src/browser/components/navigation/navigation.js